/* Sop. Essential · Ficha de producto (sections/sop-pdp.liquid) · vanilla, sin dependencias
 * - Variantes en píldoras: mueven el selector de la app de opciones (si lo hay) o el input [name=id].
 * - Barra fija en móvil con lo que falta (campos obligatorios de la app: data-validate="required").
 * - Colores rápidos bajo los campos de color de la app (rellenan el mismo campo de texto).
 * - Barra de envío gratis y añadido rápido (propiedad "Personalización", como el Kit AM6).
 * No cambia ningún nombre de propiedad de la app.
 */
(function () {
  'use strict';
  var NOTE_PROP = 'Personalización';

  function fmt(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function fire(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function visible(el) { return !!(el && el.offsetParent !== null); }
  function hex2(n) { return ('0' + Math.round(n).toString(16)).slice(-2); }
  function hsl2hex(h, s, l) {
    s /= 100; l /= 100;
    var a = s * Math.min(l, 1 - l);
    function f(n) { var k = (n + h / 30) % 12; return 255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))); }
    return ('#' + hex2(f(0)) + hex2(f(8)) + hex2(f(4))).toUpperCase();
  }
  // Paleta libre (mismo diseño que el Kit AM6): tono, intensidad y luz → #HEX
  function makePicker(box, label, withRef, onChange) {
    if (box._pk) return box._pk;
    box.classList.add('sk-picker');
    box.innerHTML =
      '<div class="sk-picker__top"><span class="sk-picker__swatch" data-pk-swatch></span>' +
      '<div><b data-pk-hex></b><small>Mueve las barras hasta dar con tu color.</small></div></div>' +
      '<label class="sk-picker__row"><span>Tono</span><input class="sk-range sk-range--hue" type="range" min="0" max="359" value="210" data-pk="h" aria-label="' + label + ': tono"></label>' +
      '<label class="sk-picker__row"><span>Intensidad</span><input class="sk-range" type="range" min="0" max="100" value="70" data-pk="s" aria-label="' + label + ': intensidad"></label>' +
      '<label class="sk-picker__row"><span>Luz</span><input class="sk-range" type="range" min="6" max="94" value="50" data-pk="l" aria-label="' + label + ': luz"></label>' +
      (withRef ? '<input class="sk-input" type="text" maxlength="30" data-pk-ref placeholder="Referencia (opcional): azul Yamaha" aria-label="' + label + ': referencia del color">' : '');
    var r = {}, ref = box.querySelector('[data-pk-ref]');
    $$(box, '[data-pk]').forEach(function (i) { r[i.dataset.pk] = i; });
    function update() {
      var hx = hsl2hex(+r.h.value, +r.s.value, +r.l.value);
      box.querySelector('[data-pk-swatch]').style.background = hx;
      box.querySelector('[data-pk-hex]').textContent = hx;
      onChange(hx, ref ? ref.value.trim() : '');
      return hx;
    }
    box.addEventListener('input', update);
    box._pk = { update: update };
    return box._pk;
  }

  function Pdp(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-sp-data]').textContent);
    this.form = document.getElementById(this.data.formId);
    this.idInput = this.form && this.form.querySelector('[name=id]');
    this.addBtn = root.querySelector('[data-sp-add]');
    this.desc = {};
    var self = this;
    String(this.data.descriptions || '').split(/\r?\n/).forEach(function (l) {
      var p = l.split('|');
      if (p.length > 1) self.desc[p[0].trim()] = p.slice(1).join('|').trim();
    });
    this.colors = String(this.data.colors || '').split(/\r?\n/).map(function (l) {
      var p = l.split('|');
      return p.length > 1 ? { name: p[0].trim(), hex: p[1].trim() } : null;
    }).filter(Boolean);
    this.variant = this.byId(this.data.initialVariant) || this.data.variants[0];
    this.cartTotal = this.data.cartTotal || 0;

    this.bindPills();
    this.bindAny();
    this.bindGallery();
    this.bindUpsell();
    this.bindBar();
    this.bindFields();
    this.watchApp();
    this.render();
  }

  Pdp.prototype.byId = function (id) {
    return this.data.variants.find(function (v) { return v.id === id; });
  };
  Pdp.prototype.selected = function () {
    return $$(this.root, '[data-sp-option]').map(function (fs) {
      var c = fs.querySelector('input[type=radio]:checked');
      return c ? c.value : null;
    });
  };
  Pdp.prototype.match = function (opts) {
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
    });
  };

  /* ---------- variantes ---------- */
  Pdp.prototype.bindPills = function () {
    var self = this;
    // texto bajo cada píldora (Mate, Galaxy, metacrilato…) solo si todo su grupo lo tiene
    $$(this.root, '.sp-pills').forEach(function (g) {
      var inputs = $$(g, 'input');
      if (!inputs.every(function (inp) { return !!self.desc[inp.value]; })) return;
      g.classList.add('sp-has-desc');
      inputs.forEach(function (inp) { inp.parentElement.querySelector('[data-sp-desc]').textContent = self.desc[inp.value]; });
    });
    $$(this.root, '[data-sp-option]').forEach(function (fs, i) {
      $$(fs, 'input[type=radio]').forEach(function (inp) {
        inp.addEventListener('change', function () { self.onOption(i, inp.value); });
      });
    });
  };
  Pdp.prototype.onOption = function (i, value) {
    var v = this.match(this.selected());
    if (!v) return;
    this.variant = v;
    if (this.idInput) this.idInput.value = v.id;
    // si la app de opciones gestiona las variantes, movemos su selector para que guarde lo mismo
    var sel = this.root.querySelector('select[name="ymq-option' + (i + 1) + '"]');
    if (sel && sel.value !== value) { sel.value = value; fire(sel); }
    var fs = this.root.querySelectorAll('[data-sp-option]')[i];
    if (fs) fs.querySelector('[data-sp-optval]').textContent = value;
    if (this.idInput) this.idInput.value = v.id;
    this.render();
  };
  Pdp.prototype.renderDeltas = function () {
    var self = this, cur = this.selected();
    $$(this.root, '[data-sp-option]').forEach(function (fs, i) {
      $$(fs, 'input[type=radio]').forEach(function (inp) {
        var o = cur.slice(); o[i] = inp.value;
        var v = self.match(o);
        var em = inp.parentElement.querySelector('[data-sp-delta]');
        inp.disabled = !v || !v.available;
        if (!em) return;
        if (!v) { em.textContent = ''; return; }
        var diff = v.price - self.variant.price;
        em.textContent = diff > 0 ? '+' + fmt(diff) : diff < 0 ? '-' + fmt(-diff) : '';
      });
    });
  };

  /* ---------- variante "Otro color": la paleta sale directamente ---------- */
  Pdp.prototype.bindAny = function () {};
  Pdp.prototype.renderAny = function () {
    var self = this, on = !!this.root.querySelector('[data-sp-any-opt]:checked');
    $$(this.root, '[data-sp-any]').forEach(function (panel) {
      var out = panel.querySelector('[data-sp-any-value]');
      panel.hidden = !on;
      out.disabled = !on;
      if (on && !panel._pk) {
        panel._pk = makePicker(panel.querySelector('[data-sp-picker]'), 'Tu color', true, function (hx, ref) {
          out.value = hx + (ref ? ' · ' + ref : '');
          if (panel._ready) self.renderStatus();
        });
        panel._pk.update();
        panel._ready = true;
      }
    });
  };

  /* ---------- precio, envío y barra ---------- */
  Pdp.prototype.extrasTotal = function () {
    return $$(this.root, '[data-up]').reduce(function (s, li) {
      if (li.querySelector('[data-up-toggle]').getAttribute('aria-pressed') !== 'true') return s;
      var v = li.querySelector('[data-up-variant]');
      var opt = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      return s + (+opt.dataset.price || 0);
    }, 0);
  };
  Pdp.prototype.render = function () {
    var v = this.variant, r = this.root;
    var price = fmt(v.price), on = v.compare > v.price;
    r.querySelector('[data-sp-price]').textContent = price;
    r.querySelector('[data-sp-bar-price]').textContent = price;
    var was = r.querySelector('[data-sp-compare]'), save = r.querySelector('[data-sp-save]');
    was.hidden = !on; save.hidden = !on;
    if (on) { was.textContent = fmt(v.compare); save.textContent = '-' + Math.floor((v.compare - v.price) * 100 / v.compare) + ' %'; }
    if (this.addBtn) {
      this.addBtn.disabled = !v.available;
      var s = this.addBtn.querySelector('span');
      if (s && !this.addBtn.classList.contains('loading')) s.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
    }
    this.renderDeltas();
    this.renderAny();
    this.renderShip();
    this.renderStatus();
  };
  Pdp.prototype.renderShip = function () {
    var box = this.root.querySelector('[data-sp-ship]');
    if (!box || !this.data.freeShipping) return;
    var inCart = this.cartTotal, sum = inCart + this.variant.price + this.extrasTotal();
    var left = this.data.freeShipping - sum;
    box.querySelector('[data-ship-bar]').style.width = Math.min(100, Math.round(sum * 100 / this.data.freeShipping)) + '%';
    box.classList.toggle('is-ok', left <= 0);
    box.querySelector('[data-ship-text]').innerHTML = left > 0
      ? 'Con este producto te faltan <b>' + fmt(left) + '</b> para el envío gratis.'
      : '<b>Envío gratis</b> desbloqueado con este pedido.';
  };

  /* ---------- campos obligatorios (app de opciones + campos propios) ---------- */
  var IG_RE = /^[A-Za-z0-9._]{1,30}$/;
  Pdp.prototype.missing = function () {
    var own = $$(this.root, '[data-sp-field]').filter(function (b) {
      if (!visible(b)) return false;
      var f = b.querySelector('input, textarea'), v = String(f && f.value || '').trim();
      if (b.dataset.kind === 'instagram' && v) return !IG_RE.test(v.replace(/^@+/, ''));
      return b.hasAttribute('data-required') && !v;
    });
    var app = $$(this.root, '.ymq-box .ymq-options-box[data-validate="required"]').filter(function (b) {
      if (!visible(b)) return false;
      var f = b.querySelectorAll('input:not([type=hidden]), textarea, select');
      if (!f.length) return false;
      return !Array.prototype.some.call(f, function (el) {
        if (el.type === 'radio' || el.type === 'checkbox') return el.checked;
        if (el.type === 'file') return el.files && el.files.length;
        return String(el.value || '').trim() !== '';
      });
    });
    // en el orden en que aparecen en la página
    return app.concat(own).sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
  };
  Pdp.prototype.label = function (b) {
    return String(b.dataset.label || '').replace(/^\s*\d+\.\s*/, '').replace(/^¿|\?$/g, '').trim().toLowerCase();
  };
  Pdp.prototype.renderStatus = function () {
    var st = this.root.querySelector('[data-sp-status]'), btn = this.root.querySelector('[data-sp-bar-btn]');
    var miss = this.missing(), self = this, ready = this.root.querySelector('[data-sp-ready]');
    if (ready) ready.textContent = miss.length ? 'Rellena los campos marcados con * y lo añades al carrito.' : (this.data.readyText || '');
    $$(this.root, '.sp-missing').forEach(function (b) {
      if (miss.indexOf(b) > -1) return;
      b.classList.remove('sp-missing');
      $$(b, '[aria-invalid]').forEach(function (f) { f.removeAttribute('aria-invalid'); });
    });
    $$(this.root, '[data-sp-field][data-kind="instagram"]').forEach(function (b) {
      var v = b.querySelector('input').value.trim().replace(/^@+/, ''), err = b.querySelector('[data-sp-err]');
      var bad = !!v && !IG_RE.test(v);
      err.hidden = !bad;
      if (bad) b.querySelector('input').setAttribute('aria-invalid', 'true');
      else if (!b.classList.contains('sp-missing')) b.querySelector('input').removeAttribute('aria-invalid');
      err.textContent = bad ? 'Solo letras, números, puntos y guiones bajos (sin espacios).' : '';
    });
    st.classList.remove('is-miss', 'is-ok');
    if (!this.variant.available) { st.textContent = 'Agotado'; btn.disabled = true; return; }
    btn.disabled = false;
    if (miss.length) {
      var names = miss.slice(0, 2).map(function (b) { return self.label(b); });
      st.textContent = 'Falta: ' + names.join(', ') + (miss.length > 2 ? ' y ' + (miss.length - 2) + ' más' : '');
      st.classList.add('is-miss');
      btn.textContent = 'Completar';
    } else {
      st.textContent = this.data.readyText || '';
      st.classList.add('is-ok');
      btn.textContent = 'Añadir al carrito';
    }
  };
  Pdp.prototype.goMissing = function () {
    var miss = this.missing();
    if (!miss.length) return false;
    miss.forEach(function (b) {
      b.classList.add('sp-missing');
      $$(b, 'input:not([type=hidden]), textarea, select').forEach(function (f) { f.setAttribute('aria-invalid', 'true'); });
    });
    var b = miss[0], f = b.querySelector('.sp-swb, .sk-range, input:not([type=hidden]):not(.sp-color-input), textarea, select');
    var y = b.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
    if (f && f.type !== 'radio' && f.type !== 'file') setTimeout(function () { f.focus({ preventScroll: true }); }, 450);
    return true;
  };

  // La app pinta sus campos después de cargar: añadimos los colores rápidos y escuchamos cambios
  Pdp.prototype.watchApp = function () {
    var self = this, tries = 0;
    function hook() {
      var box = self.root.querySelector('.ymq-box');
      if (!box) { if (++tries < 40) setTimeout(hook, 250); return; }
      if (box._sp) return;
      box._sp = true;
      box.addEventListener('input', function () { self.renderStatus(); });
      box.addEventListener('change', function () { self.renderStatus(); });
      self.addChips(box);
      self.render();
    }
    hook();
  };
  // Campos de la app cuyo nombre lleva "color": "Colores ..." (plural) admite varios
  Pdp.prototype.addChips = function (box) {
    var self = this;
    $$(box, '.ymq-options-box').forEach(function (b) {
      var label = b.dataset.label || '';
      if (!/color/i.test(label)) return;
      self.chips(b.querySelector('input[type=text]'), /colores/i.test(label));
    });
  };
  // Muestras de color en rejilla para un campo de texto de color: la muestra ES el campo
  // (el texto queda oculto pero sigue siendo lo que llega al pedido, con el mismo nombre).
  Pdp.prototype.chips = function (inp, multi) {
    if (!inp || !this.colors.length || inp._sw) return;
    inp._sw = true;
    var field = inp.closest('.ymq-options-box, .sp-field');
    var title = field && field.querySelector('.ymq_lable, .sk-group__label');
    var grid = document.createElement('div');
    grid.className = 'sk-swatches sp-swgrid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', (title ? title.textContent.replace('*', '').trim() : 'Color') + (multi ? ' (puedes elegir varios)' : ''));
    grid.innerHTML = this.colors.map(function (c) {
      return '<button type="button" class="sk-sw sp-swb" data-c="' + c.name.toUpperCase() + '" aria-pressed="false">' +
        '<span class="sk-sw__dot" style="--sw:' + c.hex + '"></span><span class="sk-sw__name">' + c.name + '</span></button>';
    }).join('') +
      '<button type="button" class="sk-sw sp-swb" data-other aria-pressed="false" aria-expanded="false">' +
      '<span class="sk-sw__dot sk-sw__dot--other"></span><span class="sk-sw__name">Otro color</span></button>';
    inp.classList.add('sp-color-input');
    inp.setAttribute('tabindex', '-1');
    inp.setAttribute('aria-hidden', 'true');
    inp.insertAdjacentElement('afterend', grid);
    var pkBox = document.createElement('div'), custom = '';
    pkBox.className = 'sp-swgrid__picker';
    pkBox.hidden = true;
    grid.insertAdjacentElement('afterend', pkBox);
    var other = grid.querySelector('[data-other]');
    function list() { return inp.value.split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean); }
    function isCustom(c) { return c.charAt(0) === '#'; }
    function pick(hx, ref) {
      var v = (hx + (ref ? ' · ' + ref : '')).toUpperCase();
      if (multi) {
        var l = list().filter(function (c) { return c !== custom; });
        l.push(v);
        inp.value = l.join(', ');
      } else {
        inp.value = v;
      }
      custom = v;
      fire(inp);
      sync();
    }
    function sync() {
      var l = list();
      $$(grid, '[data-c]').forEach(function (x) { x.setAttribute('aria-pressed', l.indexOf(x.dataset.c) > -1); });
      var on = l.some(isCustom);
      other.setAttribute('aria-pressed', on);
      if (!on && !pkBox.hidden && !multi) { pkBox.hidden = true; other.setAttribute('aria-expanded', 'false'); }
    }
    grid.addEventListener('click', function (e) {
      var bt = e.target.closest('.sp-swb');
      if (!bt) return;
      if (bt === other) {
        var open = pkBox.hidden;
        if (!open && multi) {
          // segundo toque: quita el color a medida
          inp.value = list().filter(function (c) { return c !== custom; }).join(', ');
          custom = '';
        }
        pkBox.hidden = !open;
        other.setAttribute('aria-expanded', open);
        if (open) makePicker(pkBox, title ? title.textContent.replace('*', '').trim() : 'Color', true, pick).update();
        else if (!multi) { inp.value = ''; custom = ''; }
        fire(inp);
        sync();
        return;
      }
      if (multi) {
        var l = list(), i = l.indexOf(bt.dataset.c);
        if (i > -1) l.splice(i, 1); else l.push(bt.dataset.c);
        inp.value = l.join(', ');
      } else {
        inp.value = bt.dataset.c;
        custom = '';
        pkBox.hidden = true;
        other.setAttribute('aria-expanded', 'false');
      }
      fire(inp);
      sync();
    });
    inp.addEventListener('input', sync);
    sync();
  };
  // Campos propios de la ficha (snippets/sop-pdp-fields.liquid)
  Pdp.prototype.bindFields = function () {
    var self = this, wrap = this.root.querySelector('[data-sp-fields]');
    if (!wrap) return;
    $$(wrap, '[data-sp-field]').forEach(function (b) {
      var inp = b.querySelector('input, textarea');
      if (b.dataset.kind === 'color' || b.dataset.kind === 'colors') self.chips(inp, b.dataset.kind === 'colors');
      if (b.dataset.kind === 'instagram') {
        inp.addEventListener('blur', function () { inp.value = inp.value.trim().replace(/^@+/, '').replace(/\s+/g, ''); self.renderStatus(); });
      }
    });
    wrap.addEventListener('input', function () { self.renderStatus(); });
    wrap.addEventListener('change', function () { self.renderStatus(); });
  };
  // Los campos opcionales vacíos no se envían al pedido
  Pdp.prototype.stripEmpty = function () {
    var off = $$(this.root, '[data-sp-field] input, [data-sp-field] textarea').filter(function (el) {
      if (el.closest('[data-sp-field]').dataset.kind === 'instagram') el.value = el.value.trim().replace(/^@+/, '');
      return !String(el.value).trim();
    });
    off.forEach(function (el) { el.disabled = true; });
    setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 1500);
  };

  /* ---------- barra fija ---------- */
  Pdp.prototype.bindBar = function () {
    var self = this, bar = this.root.querySelector('[data-sp-bar]');
    this.root.querySelector('[data-sp-bar-btn]').addEventListener('click', function () {
      if (self.goMissing()) return;
      if (self.addBtn) self.addBtn.click();
    });
    if (this.addBtn) {
      // Antes de que el tema / la app de opciones añadan el producto (la app lleva al carrito),
      // metemos los extras marcados. Luego repetimos el clic y sigue el flujo normal.
      this.addBtn.addEventListener('click', function (e) {
        if (self._go) { self._go = false; self.stripEmpty(); return; }
        if (self.goMissing()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        var items = self.extraItems();
        if (!items.length) { self.stripEmpty(); return; }
        e.preventDefault(); e.stopImmediatePropagation();
        self.addBtn.classList.add('loading');
        self.postExtras(items).then(function () {
          self.addBtn.classList.remove('loading');
          self._go = true;
          self.addBtn.click();
        });
      }, true);
    }
    if ('IntersectionObserver' in window && this.addBtn) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('is-on', !en[0].isIntersecting);
      }).observe(this.addBtn);
    } else bar.classList.add('is-on');
  };

  /* ---------- galería ---------- */
  Pdp.prototype.bindGallery = function () {
    var tr = this.root.querySelector('[data-sp-track]'), cnt = this.root.querySelector('[data-sp-count]');
    if (!tr || !cnt) return;
    var dots = $$(this.root, '[data-sp-dot]'), n = dots.length, t;
    tr.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(tr.scrollLeft / tr.clientWidth);
        cnt.textContent = (i + 1) + '/' + n;
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }, 60);
    }, { passive: true });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { tr.scrollTo({ left: j * tr.clientWidth, behavior: 'smooth' }); });
    });
  };

  /* ---------- añadido rápido ---------- */
  Pdp.prototype.bindUpsell = function () {
    var self = this;
    $$(this.root, '[data-up]').forEach(function (li) {
      var btn = li.querySelector('[data-up-toggle]'), note = li.querySelector('[data-up-note]');
      var sel = li.querySelector('select[data-up-variant]');
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on);
        btn.textContent = on ? 'Añadido' : 'Añadir';
        li.classList.toggle('is-on', on);
        note.hidden = !on;
        self.renderShip();
      });
      if (sel) sel.addEventListener('change', function () {
        li.querySelector('[data-up-price]').textContent = fmt(+sel.options[sel.selectedIndex].dataset.price);
        self.renderShip();
      });
    });
  };
  // Extras marcados → líneas de carrito (nota en la propiedad "Personalización")
  Pdp.prototype.extraItems = function () {
    return $$(this.root, '[data-up]').filter(function (li) {
      return li.querySelector('[data-up-toggle]').getAttribute('aria-pressed') === 'true';
    }).map(function (li) {
      var item = { id: +li.querySelector('[data-up-variant]').value, quantity: 1 };
      var n = li.querySelector('[data-up-note]').value.trim();
      if (n) { item.properties = {}; item.properties[NOTE_PROP] = n; }
      return item;
    });
  };
  Pdp.prototype.postExtras = function (items) {
    var self = this;
    return fetch((window.routes && routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || 'No se pudieron añadir los extras.');
      $$(self.root, '[data-up]').forEach(function (li) {
        var btn = li.querySelector('[data-up-toggle]');
        btn.setAttribute('aria-pressed', 'false'); btn.textContent = 'Añadir'; li.classList.remove('is-on');
        li.querySelector('[data-up-note]').hidden = true;
      });
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { self.cartTotal = c.total_price || 0; self.renderShip(); });
    }).catch(function (e) { self.toast(e.message || 'No se pudieron añadir los extras.'); });
  };
  Pdp.prototype.toast = function (msg) {
    var t = this.root.querySelector('[data-sp-toast]');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(this._t);
    this._t = setTimeout(function () { t.hidden = true; }, 3500);
  };

  function init() {
    $$(document, '[data-sp]').forEach(function (el) { if (!el._sp) el._sp = new Pdp(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
